import { render, staticRenderFns } from "./LoanMonthly.vue?vue&type=template&id=47bdd09d&scoped=true&"
import script from "./LoanMonthly.vue?vue&type=script&lang=ts&"
export * from "./LoanMonthly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bdd09d",
  null
  
)

export default component.exports